import { Component } from '@angular/core';
import { AppService } from '../../services/app.service';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  readonly viewDataIngestionModule: string[] = ['app.dcr-portal.s3-data-transfer.view'];

  readonly viewQueryInterfaceModule: string[] = [
    'app.dcr-portal.query-interface.view',
    'app.dcr-portal.query-history.view',
    'app.dcr-portal.query-result.view',
    'app.dcr-portal.activation.view',
    'app.dcr-portal.audience-export-history.view',
  ];

  readonly viewDataConnectionModule: string[] = [
    'app.dcr-portal.data-connection.action.create',
    'app.dcr-portal.data-connection.action.view',
    'app.dcr-portal.data-connection.action.delete',
    'app.dcr-portal.data-connection.action.edit',
  ];

  readonly viewUserManagementModule: string[] = [
    'app.dcr-portal.user-management.view',
    'app.dcr-portal.user-management.action.create',
    'app.dcr-portal.user-management.action.view',
    'app.dcr-portal.user-management.action.delete',
    'app.dcr-portal.user-management.action.edit',
  ];

  readonly viewBiModule: string[] = ['app.dcr-portal.bi.all'];
  readonly viewMlModule: string[] = ['app.dcr-portal.ml.all'];

  readonly viewCollaborationModule: string[] = ['app.dcr-portal.collaboration.all'];

  constructor(
    public appService: AppService,
    public authService: AuthService,
  ) {}
}
